import { useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box, IconButton, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { CopyButton } from '../../../../components/CopyButton';

export interface Props {
  action: () => Promise<unknown>;
  onClose: () => void;
}

export const CalcRebalanceDialog = ({ action, onClose }: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [result, setResult] = useState<any>(null);
  const [complete, setComplete] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    action()
      .then((response) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res = response as any;
        if (res?.success) {
          setResult(res.result?.result ?? res.result);
        } else {
          setError(res?.errorMessage ?? 'Произошла ошибка на сервере');
        }
      })
      .catch((e) => setError((e as Error).toString()))
      .finally(() => setComplete(true));
  }, [action]);

  return (
    <Dialog maxWidth="md" fullWidth open onClose={onClose}>
      <DialogTitle align="center">Балансировка клиента</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        {!complete && <Typography>Расчёт балансировки клиента...</Typography>}
        {error && (
          <Alert severity="error" sx={{ mt: 1 }}>
            {error}
          </Alert>
        )}
        {complete && result && (
          <Box sx={{ overflow: 'auto', maxHeight: 400 }}>
            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
              {JSON.stringify(result, null, 2)}
            </pre>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Закрыть</Button>
        <CopyButton text={JSON.stringify(result, null, 2)} disabled={!complete} />
      </DialogActions>
    </Dialog>
  );
};
